import { useState, useEffect } from 'react';

/* MobX */
import { observer } from 'mobx-react-lite';

/* MUI */
import { Accordion, AccordionDetails, AccordionSummary, Checkbox, Grid, TextField, Typography } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { FileUploadButton } from '../../form-input/form-file-upload-button.component';

const ServiceAgreementAppeal = observer(({
  expanded,
  handleAccordianChange,
  statusSA,
  statusChange,
  saNum,
  chargeAllocations,
  handleChargeAllocationsAccountChange,
  handleChargeAllocationsAccountSet,
  handleChargeAllocationsChange,
  saFileName,
  saFileChange,
  area,
  mapBlock,
  saAccounts }) => {
  const [warning, setWarning] = useState("");
  const { Accounts, F_Applicant_Comments_SA } = chargeAllocations;

  // check SA info
  useEffect(() => {
    let num = 0;
    let sum = 0;
    sum = saAccounts.reduce(
      (accumulator, currentValue) => accumulator + parseFloat(currentValue.f_Appealed_Distb_Percent),
      sum);
    num = saAccounts.length;

    if (statusSA === 'submitted') {
      setWarning('');
    } else {
      if (sum <= 100 && Math.round(sum) === 100 && num >= 2) {
        statusChange("ready");
        if (num !== saNum) {
          setWarning("*Not match number of SAs on Map Block Lot");
        } else {
          setWarning("");
        }
      } else {
        statusChange("initial");
        if (sum !== 100) {
          setWarning("*The charge distribution should add to 100% for all accounts");
        } else if (num < 2) {
          setWarning("*If there's only one account on the map block lot, then the charge will be allocated 100% to the sole account")
        }
      }
    }
  }, [statusSA, saAccounts, saNum])


  return (
    <Accordion expanded={expanded === 'panel4'} onChange={handleAccordianChange('panel4')}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} id="SAChargeAllocAppeal" style={{ backgroundColor: "whitesmoke" }}>
        <Typography variant="h6" gutterBottom color="primary">
          <Checkbox
            checked={statusSA === "submitted" || statusSA === "ready"}
            disabled={statusSA === "submitted"}
            color="primary"
            inputProps={{ 'aria-label': 'secondary checkbox' }}
          />
          Enter Information for Revised Service Agreement Charge Allocations Appeal
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body1">
              By default, the stormwater charge for a property is equally split across all SFPUC accounts with a sewer
              service agreement on that property. This appeal needs a signed document, such as a letter of agreement,
              from all SFPUC account holders agreeing to a new customized split of the stormwater charge.
            </Typography>
            {statusSA === "submitted" &&
              <Typography variant="h6" color="error">
                There is a current appeal pending. Please contact us at (415)-551-3000 before submitting a new request.
              </Typography>}
          </Grid>
          <Grid item xs={6} align="center">
            <Typography variant="h6">
              {mapBlock}
            </Typography>
            <Typography variant="body2">Map Block Lot</Typography>
          </Grid>
          <Grid item xs={6} align="center">
            <Typography variant="h6" color="textPrimary">{saAccounts?.length ? saAccounts.length : saNum}</Typography>
            <Typography variant="body2">Number of Service Agreements</Typography>
          </Grid>
          <Grid item xs={6} align="center">
            <Typography>Account Number</Typography>
          </Grid>
          <Grid item xs={6} align="center">
            <Typography>Charge (%)</Typography>
          </Grid>

          {saAccounts.length > 0 && saAccounts.map((element, index) =>
          (<Grid item xs={12} key={index}>
            <Grid container spacing={2}>
              <Grid item xs={6} align="center">
                <TextField
                  name="acc_no"
                  variant="outlined"
                  fullWidth
                  label={`Account Number ${index + 1}`}
                  value={element.f_Appeal_Account_Num}
                  InputProps={{
                    readOnly: true,
                  }}
                //onChange={event => { handleChargeAllocationsAccountChange(event.target.value, index, "f_Appeal_Account_Num", Accounts) }} InputProps={{ readOnly: statusSA === "submitted" }} 
                />
              </Grid>
              <Grid item xs={6} align="center">
                <TextField
                  name="acc_charge"
                  variant="outlined"
                  label="Charge Percentage"
                  fullWidth
                  value={element.f_Appealed_Distb_Percent ? element.f_Appealed_Distb_Percent : ''}
                  onChange={event => { handleChargeAllocationsAccountChange(event.target.value, index, "f_Appealed_Distb_Percent", saAccounts) }}
                  InputProps={{ readOnly: statusSA === "submitted", }}
                />
              </Grid>
            </Grid>
          </Grid>)
          )}
          {warning &&
            <Grid item xs={12} align="right" >
              <Typography color="error">{warning}</Typography>
            </Grid>
          }
          <Grid item xs={12} align="left">
            <FileUploadButton
              description={"Attach SA Level Area Related Information"}
              fileChange={saFileChange}
              disabled={statusSA === "submitted"} />
          </Grid>
          <Grid item xs={12} align="center">
            <TextField name="F_Applicant_Comments_SA" variant="outlined" label="Applicant Comments" fullWidth
              value={F_Applicant_Comments_SA} onChange={handleChargeAllocationsChange} InputProps={{ readOnly: statusSA === "submitted" }} />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  )
})

export default ServiceAgreementAppeal;